import React from 'react';
import { Input, Switch } from 'rizzui';
import CustomSelect from '../../../components/forms/CustomSelect';
import CustomTextDelayInput from '../../../components/forms/CustomTextDelayInput';
import DateField from '../../../components/forms/DateField';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import useCompanies from '../../../hooks/api-calls/useCompanies';
import useClients from '../../../hooks/api-calls/useClients'; // <- FALTABA
import { FilterOptions } from '../../../hooks/useFilters';
import { isEqual } from 'lodash';

interface InvoicesFiltersProps {
    updateFilters: (filters: any) => void;
    filters: FilterOptions;
    type?: 'proforma' | 'invoice';
}

const InvoicesFilters: React.FC<InvoicesFiltersProps> = ({ filters, updateFilters, type }) => {
    const { userCan } = usePrivilege();
    const { getCompaniesList } = useCompanies();
    const { getClientsList } = useClients();

    // Helpers --------------------------------------------------------------------
    const setRange = (key: string, next: { from?: any; to?: any } | null) => {
        const curr = filters.filter_filters?.[key];
        if (next && !isEqual(curr, next)) updateFilters({ [key]: next });
        else if (!next && curr) updateFilters({ [key]: null });
    };

    const parseNumber = (v: any) => {
        if (v === '' || v === null || v === undefined) return undefined;
        const n = Number(v);
        return Number.isFinite(n) ? n : undefined;
    };

    const triOptions = [
        { label: 'Todos', value: 'null' },
        { label: 'Sí', value: true },
        { label: 'No', value: false },
    ];

    // UI -------------------------------------------------------------------------
    return (
        <>
            {/* Fechas */}
            <DateField
                isClearable
                className="w-full"
                label="Fechas de facturación"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.invoice_date?.from ? new Date(filters.filter_filters.invoice_date.from) : null}
                endDate={filters.filter_filters?.invoice_date?.to ? new Date(filters.filter_filters.invoice_date.to) : null}
                onChange={(date: any) => {
                    const current = filters.filter_filters?.invoice_date;
                    const next = date ? { from: date[0], to: date[1] } : null;
                    if (next && !isEqual(current, next)) updateFilters({ invoice_date: next });
                    else if (!next && current) updateFilters({ invoice_date: null });
                }}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de pago"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.payment_date?.from ? new Date(filters.filter_filters.payment_date.from) : null}
                endDate={filters.filter_filters?.payment_date?.to ? new Date(filters.filter_filters.payment_date.to) : null}
                onChange={(date: any) => {
                    const current = filters.filter_filters?.payment_date;
                    const next = date ? { from: date[0], to: date[1] } : null;
                    if (next && !isEqual(current, next)) updateFilters({ payment_date: next });
                    else if (!next && current) updateFilters({ payment_date: null });
                }}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de cancelación"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.cancel_date?.from ? new Date(filters.filter_filters.cancel_date.from) : null}
                endDate={filters.filter_filters?.cancel_date?.to ? new Date(filters.filter_filters.cancel_date.to) : null}
                onChange={(date: any) => {
                    const current = filters.filter_filters?.cancel_date;
                    const next = date ? { from: date[0], to: date[1] } : null;
                    if (next && !isEqual(current, next)) updateFilters({ cancel_date: next });
                    else if (!next && current) updateFilters({ cancel_date: null });
                }}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fechas de creación"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.created_at?.from ? new Date(filters.filter_filters.created_at.from) : null}
                endDate={filters.filter_filters?.created_at?.to ? new Date(filters.filter_filters.created_at.to) : null}
                onChange={(date: any) => {
                    const current = filters.filter_filters?.created_at;
                    const next = date ? { from: date[0], to: date[1] } : null;
                    if (next && !isEqual(current, next)) updateFilters({ created_at: next });
                    else if (!next && current) updateFilters({ created_at: null });
                }}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de actualización"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.updated_at?.from ? new Date(filters.filter_filters.updated_at.from) : null}
                endDate={filters.filter_filters?.updated_at?.to ? new Date(filters.filter_filters.updated_at.to) : null}
                onChange={(date: any) => {
                    const current = filters.filter_filters?.updated_at;
                    const next = date ? { from: date[0], to: date[1] } : null;
                    if (next && !isEqual(current, next)) updateFilters({ updated_at: next });
                    else if (!next && current) updateFilters({ updated_at: null });
                }}
            />

            {/* Compañía (si superadmin) */}
            {userCan('list', 'company') && (
                <CustomSelect
                    isSearchable
                    id="company"
                    label="Compañía"
                    options={[{ label: 'Todas', value: 'null' }, ...getCompaniesList()]}
                    value={
                        getCompaniesList().find((i: any) => i.value === filters.filter_filters?.company) ??
                        { label: 'Todas', value: 'null' }
                    }
                    onChange={(e: any) => {
                        if (e.value === 'null') updateFilters({ company: null });
                        else updateFilters({ company: e.value });
                    }}
                />
            )}

            {/* Cliente */}
            {/*<CustomSelect*/}
            {/*    isSearchable*/}
            {/*    id="client"*/}
            {/*    label="Cliente"*/}
            {/*    options={[{ label: 'Todos', value: 'null' }, ...getClientsList()]}*/}
            {/*    value={*/}
            {/*        getClientsList().find((i: any) => i.value === filters.filter_filters?.client) ??*/}
            {/*        { label: 'Todos', value: 'null' }*/}
            {/*    }*/}
            {/*    onChange={(e: any) => {*/}
            {/*        if (e.value === 'null') updateFilters({ client: null });*/}
            {/*        else updateFilters({ client: e.value });*/}
            {/*    }}*/}
            {/*/>*/}

            {/* Rangos numéricos */}
            <div className="grid grid-cols-2 gap-3">
                <CustomTextDelayInput
                    id="kg_quantity_from"
                    label="Kg desde"
                    type="number"
                    value={filters.filter_filters?.kg_quantity?.from ?? ''}
                    onChange={(v: any) => {
                        const from = parseNumber(v.target.value);
                        const to = filters.filter_filters?.kg_quantity?.to;
                        // Enviar filtro si hay al menos un valor válido
                        if (from !== undefined || to !== undefined) {
                            setRange('kg_quantity', { from, to });
                        } else {
                            setRange('kg_quantity', null);
                        }
                    }}
                    filters={filters}
                    updateFilters={updateFilters}
                />

                <CustomTextDelayInput
                    id="kg_quantity_to"
                    label="Kg hasta"
                    type="number"
                    value={filters.filter_filters?.kg_quantity?.to ?? ''}
                    onChange={(v: any) => {
                        const to = parseNumber(v.target.value);
                        const from = filters.filter_filters?.kg_quantity?.from;
                        // Enviar filtro si hay al menos un valor válido
                        if (from !== undefined || to !== undefined) {
                            setRange('kg_quantity', { from, to });
                        } else {
                            setRange('kg_quantity', null);
                        }
                    }}
                    filters={filters}
                    updateFilters={updateFilters}
                />
            </div>

            <div className="grid grid-cols-2 gap-3">
                <CustomTextDelayInput
                    id="unit_price_from"
                    label="Precio/u desde"
                    type="number"
                    value={filters.filter_filters?.unit_price?.from ?? ''}
                    onChange={(v: any) => {
                        const from = parseNumber(v.target.value);
                        const to = filters.filter_filters?.unit_price?.to;
                        // Enviar filtro si hay al menos un valor válido
                        if (from !== undefined || to !== undefined) {
                            setRange('unit_price', { from, to });
                        } else {
                            setRange('unit_price', null);
                        }
                    }}
                    filters={filters}
                    updateFilters={updateFilters}
                />

                <CustomTextDelayInput
                    id="unit_price_to"
                    label="Precio/u hasta"
                    type="number"
                    value={filters.filter_filters?.unit_price?.to ?? ''}
                    onChange={(v: any) => {
                        const to = parseNumber(v.target.value);
                        const from = filters.filter_filters?.unit_price?.from;
                        // Enviar filtro si hay al menos un valor válido
                        if (from !== undefined || to !== undefined) {
                            setRange('unit_price', { from, to });
                        } else {
                            setRange('unit_price', null);
                        }
                    }}
                    filters={filters}
                    updateFilters={updateFilters}
                />
            </div>

            <div className="grid grid-cols-2 gap-3">
                <CustomTextDelayInput
                    id="total_amount_from"
                    label="Importe total desde"
                    type="number"
                    value={filters.filter_filters?.total_amount?.from ?? ''}
                    onChange={(v: any) => {
                        const from = parseNumber(v.target.value);
                        const to = filters.filter_filters?.total_amount?.to;
                        // Enviar filtro si hay al menos un valor válido
                        if (from !== undefined || to !== undefined) {
                            setRange('total_amount', { from, to });
                        } else {
                            setRange('total_amount', null);
                        }
                    }}
                    filters={filters}
                    updateFilters={updateFilters}
                />
                <CustomTextDelayInput
                    id="total_amount_to"
                    label="Importe total hasta"
                    type="number"
                    value={filters.filter_filters?.total_amount?.to ?? ''}
                    onChange={(v: any) => {
                        const to = parseNumber(v.target.value);
                        const from = filters.filter_filters?.total_amount?.from;
                        // Enviar filtro si hay al menos un valor válido
                        if (from !== undefined || to !== undefined) {
                            setRange('total_amount', { from, to });
                        } else {
                            setRange('total_amount', null);
                        }
                    }}
                    filters={filters}
                    updateFilters={updateFilters}
                />
            </div>

            <div className="grid grid-cols-2 gap-3">
                <CustomTextDelayInput
                    id="iva_tax_from"
                    label="IVA % desde"
                    type="number"
                    value={filters.filter_filters?.iva_tax?.from ?? ''}
                    onChange={(v: any) => {
                        const from = parseNumber(v.target.value);
                        const to = filters.filter_filters?.iva_tax?.to;
                        // Enviar filtro si hay al menos un valor válido
                        if (from !== undefined || to !== undefined) {
                            setRange('iva_tax', { from, to });
                        } else {
                            setRange('iva_tax', null);
                        }
                    }}
                    filters={filters}
                    updateFilters={updateFilters}
                />
                <CustomTextDelayInput
                    id="iva_tax_to"
                    label="IVA % hasta"
                    type="number"
                    value={filters.filter_filters?.iva_tax?.to ?? ''}
                    onChange={(v: any) => {
                        const to = parseNumber(v.target.value);
                        const from = filters.filter_filters?.iva_tax?.from;
                        // Enviar filtro si hay al menos un valor válido
                        if (from !== undefined || to !== undefined) {
                            setRange('iva_tax', { from, to });
                        } else {
                            setRange('iva_tax', null);
                        }
                    }}
                    filters={filters}
                    updateFilters={updateFilters}
                />
            </div>

            {/* Tri-state: pagada / cancelada */}
            <div className="grid grid-cols-2 gap-3">
                {!type && (
                    <label className="flex items-center gap-2 text-sm">
                        <Switch
                            checked={filters.filter_filters?.is_paid === true}
                            onChange={(e) => updateFilters({ is_paid: e.target.checked ? true : null })}
                        />
                        Pagada
                    </label>
                )}


                <label className="flex items-center gap-2 text-sm">
                    <Switch
                        checked={filters.filter_filters?.is_cancel === true}
                        onChange={(e) => updateFilters({ is_cancel: e.target.checked ? true : null })}
                    />
                    Cancelada
                </label>
            </div>

            {/* (Opcional) Presencia de documento
          <CustomSelect
            id="has_document"
            label="Con documento"
            options={[
              { label: 'Todos', value: 'null' },
              { label: 'Sí', value: true },
              { label: 'No', value: false },
            ]}
            value={
              [{ label: 'Todos', value: 'null' }, { label: 'Sí', value: true }, { label: 'No', value: false }]
                .find(o => String(o.value) === String(filters.filter_filters?.has_document ?? 'null')) ?? { label: 'Todos', value: 'null' }
            }
            onChange={(e: any) => {
              updateFilters({ has_document: e.value === 'null' ? null : e.value });
            }}
          />
          */}

        </>
    );
};

export default InvoicesFilters;
